import { useCurrentUserId } from 'modules/Auth/hooks';
import { Column, Table } from 'components/Table';
import { Button } from 'components/Button';
import { Link } from 'components/Link';
import { useRouter } from 'next/router';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { HomeCard } from 'modules/Home/components/HomeCard';
import { IconPlus } from 'components/Icons/index';
import { useMyComputeRecord } from 'modules/Home/hooks/useMyCompute';
import { HomeCardId, mapIdToTitle } from 'modules/Home/constants';
import { footer, tableContainer } from 'modules/Home/cards/MyCompute.styles';
import { NodepoolTableData, useComputeTableColumns } from 'modules/Compute/hooks/useComputeTableColumns';

const nodepoolTableColumns = useComputeTableColumns<NodepoolTableData>();

const columns: Column<NodepoolTableData>[] = [
  nodepoolTableColumns.makeClusterIdColumn(),
  nodepoolTableColumns.makeNodepoolIdColumn(),
  nodepoolTableColumns.makeClusterTypeColumn(),
  nodepoolTableColumns.makeProviderColumn(),
  nodepoolTableColumns.makeRegionColumn(),
  nodepoolTableColumns.makeInstanceNameColumn(),
  nodepoolTableColumns.makeHardwareColumn(),
  nodepoolTableColumns.makeAutoscalingColumn(),
  nodepoolTableColumns.makeCostColumn(),
  nodepoolTableColumns.makeCreatedAtColumn(),
  nodepoolTableColumns.makeActionsColumn({ meta: { sticky: 'right' } }),
];

export function MyCompute() {
  const { track } = useDataCollection();
  const userOrOrgId = useCurrentUserId();
  const router = useRouter();

  const { computeRecord, isLoading } = useMyComputeRecord({ userOrOrgId });

  if (!userOrOrgId) {
    return null;
  }

  return (
    <HomeCard
      title={mapIdToTitle[HomeCardId.MyCompute]}
      description="Use dedicated compute to deploy your own or Community models."
      action={
        <Button
          size="md"
          variant="tertiary"
          LeftIcon={IconPlus}
          onClick={() => {
            track('Home Page -> Create Cluster Clicked');
            router.push('/compute/create');
          }}
        >
          Create a Cluster
        </Button>
      }
    >
      <div className={tableContainer}>
        <Table<NodepoolTableData>
          tableOptions={{
            columns,
            data: computeRecord as NodepoolTableData[],
          }}
          isInitializing={isLoading}
          maxHeight={300}
        />
        {computeRecord?.length < 2 && (
          <div className={footer}>
            <div className="text-content">
              Want even more control?{' '}
              <Link className="link" href="/compute">
                Create a custom configuration
              </Link>{' '}
            </div>
          </div>
        )}
      </div>
    </HomeCard>
  );
}
